import React, { useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import ReactGA from 'react-ga';

const GAInitialize = (props) => {
  const logGA = (location) => {
    console.log('location', location)

    ReactGA.set({ page: location.pathname });
    ReactGA.pageview(location.pathname)
  }
  const initilize = () => {
    const GA_TRACKING_ID = process.env.REACT_APP_GA_TRACKING_ID
    ReactGA.initialize(GA_TRACKING_ID)
    logGA(props.location)
  }

  useEffect(() => {
    initilize()
    let unlistenHistory = props.history.listen(logGA)
    return () => {
      unlistenHistory()
    }
  }, [])

  return null
}

export default withRouter(GAInitialize)



// WEBPACK FOOTER //
// ./src/components/GAInitialize.js